import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { Robot } from 'src/app/models/robot';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-view-my-robots',
  templateUrl: './view-my-robots.component.html',
  styleUrls: ['./view-my-robots.component.css'],
  standalone: true,
  imports: [SharedModule]
})
export class ViewMyRobotsComponent {
  @Input() public robot: Robot;

  constructor(protected ref: NbDialogRef<ViewMyRobotsComponent>) {}

  public close() {
    this.ref.close();
  }
}
